import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { map } from "rxjs/operators";
import { PhoneItemInfo } from "../phone-admin-page.component";
import { LineInfo } from "../phoneDetail/phone-detail.component";
import { PhoneMake } from "@onsip/common/interfaces/phone-info";

@Component({
  selector: "onsip-phone-lines",
  templateUrl: "./phone-lines.component.html",
  styleUrls: ["./phone-lines.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PhoneLinesComponent {
  @Input() phoneInfo!: PhoneItemInfo;
  @Input() lines!: Array<LineInfo>;
  @Input() expansionModuleName = "";
  @Output() editPanel = new EventEmitter<void>();

  lessThanMediumBreakpoint = this.breakpointObserver
    .observe([Breakpoints.Small, Breakpoints.XSmall])
    .pipe(map(result => result.matches));

  constructor(private breakpointObserver: BreakpointObserver) {}

  toggleLinePanel(): void {
    this.editPanel.emit();
  }

  get isPolycomPhone() {
    return this.phoneInfo.make === PhoneMake.Polycom;
  }
}
